/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var Inotify = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.0016C13.1 22.0016 13.9 21.1016 13.9 20.1016H10C10.1 21.1016 10.9 22.0016 12 22.0016Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7008 16.3L17.9008 13V10C17.9008 7.5 16.3008 5.3 14.0008 4.4C14.0008 4.3 14.0008 4.1 14.0008 4C14.1008 2.9 13.1008 2 12.0008 2C11.7008 2 11.4008 2.1 11.2008 2.2C10.5008 2.5 9.90084 3.2 9.90084 4.1C9.90084 4.2 9.90084 4.3 9.90084 4.4C7.50084 5.2 5.90084 7.5 5.90084 10.1V13.1L4.20084 16.4C4.00084 16.8 4.00084 17.3 4.10084 17.7C4.30084 18.2 4.60084 18.6 5.00084 18.8C5.30084 18.9 5.60084 19 5.90084 19H17.9008C19.0008 19 19.5008 18.6 19.7008 18.3C19.9008 17.9 20.2008 17.3 19.7008 16.3ZM17.9008 17.3H5.80084C5.70084 17.3 5.70084 17.2 5.70084 17.1L7.50084 13.4V10C7.50084 8.2 8.70084 6.5 10.4008 6L11.0008 5.8C11.3008 6 11.7008 6.1 12.0008 6.1C12.3008 6.1 12.7008 6 12.9008 5.9L13.3008 6C15.0008 6.6 16.2008 8.2 16.2008 10.1V13.5L18.2008 17.1C18.2008 17.2 18.3008 17.3 18.3008 17.3C18.2008 17.3 18.1008 17.3 17.9008 17.3Z",
    fill: "#495057"
  }));
});